import { AppRoute } from "app";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { clientConfigAtom } from "atoms/clientConfig";

export const ExternalRedirect = () => {
  const { flowCompletionRedirectUrl } = useAtomValue(clientConfigAtom);
  const navigate = useNavigate();

  useEffect(() => {
    if (flowCompletionRedirectUrl) {
      navigate(flowCompletionRedirectUrl);
    } else {
      navigate(AppRoute.ApiError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowCompletionRedirectUrl]);

  return null;
};
